import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nutanixPrism = defineConnector({
  identifier: "nutanixPrism",
  name: "Nutanix Prism",
  tagLine: "Infrastructure and cluster management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://prism\\.example\\.com:9440/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Create credentials in Nutanix Prism",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://www.nutanix.dev/api_reference/apis/prism_v3.html](https://www.nutanix.dev/api_reference/apis/prism_v3.html) to create credentials with the permissions you want 3B to use.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "Nutanix Prism base URL",
          placeholder: "https://prism.example.com:9440",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://prism.example.com:9440/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ??
        (({ url }) => `${url}/api/nutanix/v3/clusters/list`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
